module.exports = __webpack_public_path__ + "img/big_11B07_yellow.39862c82.png";